import { baseUrl } from './helpers';

/*
  Helpers
*/
const getAllCheckLists = (token: string) => fetch(`${baseUrl}/checklists`, {
  method: 'GET',
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

const getChecklistById = (checklistId: string, token: string) => fetch(`${baseUrl}/checklists/${checklistId}`, {
  method: 'GET',
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

const createChecklist = (checklistObj: {
  checklistTitle: string,
  checklistDescription?: string,
}, token: string) => fetch(`${baseUrl}/checklists`, {
  method: 'POST',
  headers: {
    'Content-type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify(checklistObj),
});

const deleteChecklistById = (checklistId: string, token: string) => fetch(`${baseUrl}/checklists/${checklistId}`, {
  method: 'DELETE',
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export {
  getAllCheckLists,
  getChecklistById,
  createChecklist,
  deleteChecklistById,
};
